import { reminderTime, type SessionReminderFrame } from './frame';

export function canEnableDesktopAlerts(): boolean {
    return typeof Notification !== 'undefined' && Notification.permission === 'default';
}

export function createReminderToast(frame: SessionReminderFrame, onDismiss: () => void, onEnable: () => void) {
    const root = document.createElement('section');
    root.className = 'card bg-dark text-white border-warning shadow p-3';
    root.dataset.sessionReminder = frame.campaign_session_id;
    root.setAttribute('role', 'status');
    root.setAttribute('aria-live', 'polite');
    root.style.pointerEvents = 'auto';
    const name = document.createElement('strong');
    name.className = 'd-block text-break';
    const time = document.createElement('div');
    time.className = 'small mb-2';
    time.dataset.sessionReminderTime = '';
    const actions = document.createElement('div');
    actions.className = 'd-flex flex-wrap gap-2';
    const link = document.createElement('a');
    link.className = 'btn btn-primary btn-sm';
    link.textContent = 'Go to campaign';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'btn btn-outline-light btn-sm';
    close.textContent = 'Dismiss';
    close.addEventListener('click', onDismiss);
    actions.append(link, close);
    const enable = document.createElement('button');
    enable.type = 'button';
    enable.className = 'btn btn-link btn-sm text-info p-0 mt-2 align-self-start';
    enable.textContent = 'Enable desktop alerts';
    enable.addEventListener('click', onEnable);
    root.append(name, time, actions, enable);
    function update(next: SessionReminderFrame): void {
        name.textContent = next.campaign_name;
        link.href = next.url;
        time.textContent = reminderTime(next);
        enable.hidden = !canEnableDesktopAlerts();
    }
    update(frame);
    return { root, update };
}
